import * as React from 'react'
import styled from 'styled-components'
import sanitizeHTML from '../../../services/sanitizeHTML'

import SideModal from '../../ui/SideModal/SideModal'
import RewardsList from '../RewardsList/containers/RewardsList'
import PointsCard from '../PointsCard/containers/PointsCard'
import InsufficientPointsModal from '../InsufficientPointsModal/InsufficientPointsModal'
import RedeemSuccessModal from '../RedeemSuccessModal/RedeemSuccessModal'
import DialogModal from '../../ui/DialogModal/DialogModal'

import * as LoyaltyApiService from '../../../services/api/requests/Loyalty'
import media from '../../../services/generateMediaQueries'
import { setGAEvent } from '../../../services/analytics/google-analytics'
import DesktopLeaderboard from '../../ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileRectangle from '../../ads/MobileRectangle/MobileRectangle'
import ResponsiveAdsContainer from '../../ads/ResponsiveAdsContainer/ResponsiveAdsContainer'
// import InnerPageRectangle from '../../ads/InnerPageRectangle/InnerPageRectangle'
// import InnerPageLeaderboard from '../../ads/InnerPageLeaderboard/InnerPageLeaderboard'

const Container = styled.div`
  padding: 3rem;
  padding-top: 0;
  margin-top: -3rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 500px;

  &::after {
    flex: 0 0 3.75rem;
    content: '';
  }

  ${media.lessThan('small')`
    padding: 1.5rem;
    margin-top: -4.5rem;
  `}
`

const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  color: #ffffff;
`

const SubTitle = styled.h3`
  font-size: 1rem;
  font-weight: var(--font-weight);
  margin-top: 0;
  color: #ffffff;
`

const Body = styled.div`
  font-size: 0.875rem;

  > p {
    &:first-child {
      margin-top: 0;
    }
  }

  > figure {
    margin: 0;

    > img {
      max-width: 100%;
    }

    > table {
      width: 100%;
      margin: 0 -0.5rem;
      border-collapse: collapse;
      td,
      th {
        padding: 0 0.5rem;
        border: 1px solid #ccc;
      }
    }
  }

  margin-bottom: 2rem;
`

const StyledBanner = styled.div`
  width: 100%;
  min-height: 320px;
  padding: 2.5rem;
  padding-bottom: 4.5rem;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  ${media.lessThan('small')`
    padding-bottom: 3rem;
  `}
`

const StyledRewardsList = styled(RewardsList)`
  margin-bottom: 2.5rem;
`

const About = styled.h3`
  font-size: 1rem;
  text-transform: uppercase;
`

const StyledPointsCard = styled(PointsCard)`
  position: initial;
  overflow: unset;
  margin: 0;
  margin-bottom: 0.75rem;
  flex-grow: 1;
`

const RemindersList = styled.ul`
  margin: 0;
  margin-bottom: 1rem;
  padding-left: 1rem;
`

const Reminder = styled.li`
  font-size: 0.875rem;
`

const PointsCardContainer = styled.div`
  position: relative;
  /* display: flex; */
`

function RewardsModal(props) {
  const {
    show,
    onClose: onModalClose,
    loading,
    data = [],
    accessToken,
    advanceAccount,
    setLoyaltyPoints,
    displayMyVoucher,
  } = props
  const { merchantName, merchantTagLine, body, imageUrl, reminders } =
    data[0] || {}
  const [showRedeem, setShowRedeem] = React.useState(false)
  const [redeemError, setRedeemError] = React.useState(null)
  const [showInsufficientError, setShowInsufficientError] = React.useState(null)
  const [showRedeemSuccess, setShowRedeemSuccess] = React.useState(false)
  const [redeemRewardObject, setRedeemRewardObject] = React.useState(null)
  // const [adType, setAdType] = React.useState(false)

  // React.useEffect(() => {
  //   setAdType(Boolean(Math.random() >= 0.5))
  // }, [])

  const redeemReward = rewardId => {
    return new Promise((resolve, reject) => {
      LoyaltyApiService.redeemReward(rewardId.toString(), accessToken)
        .then(response => {
          setLoyaltyPoints({})
          LoyaltyApiService.getLoyaltyPoints(accessToken).then(
            loyaltyResponse => {
              setLoyaltyPoints(loyaltyResponse.data)
            },
          )
          setShowRedeem(false)
          setShowRedeemSuccess(response.data)
          setGAEvent(
            'voucher_redeem',
            'voucher_redeem_success',
            redeemRewardObject.title,
          )
          resolve(response)
        })
        .catch(error => {
          const { data: errorData = {} } = error.response || {}
          const { message = 'Network Error' } = errorData || {}

          if (message.toLowerCase().indexOf('insufficient points') >= 0) {
            setShowInsufficientError(true)
          } else {
            setRedeemError(message)
          }

          setShowRedeem(false)
          reject(error)
        })
    })
  }

  const onDialogClose = () => {
    setShowRedeem(false)
  }

  const onClose = () => {
    onModalClose()
  }

  const displayProfileVoucher = showVoucher => {
    setShowRedeemSuccess(false)
    displayMyVoucher(showVoucher)
  }

  React.useEffect(() => {
    if (merchantName) {
      setGAEvent('rewards_merchant', 'view_merchant_voucher_list', merchantName)
    }
  })

  return (
    <>
      <SideModal
        show={show}
        onClose={e => {
          e.stopPropagation()
          onClose()
        }}
        loading={loading}
      >
        <StyledBanner
          style={{
            background: `
                linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)),
                linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)),
                url("${imageUrl}") center / cover`,
          }}
        >
          <Title>{merchantName}</Title>
          <SubTitle>{merchantTagLine}</SubTitle>
        </StyledBanner>
        <Container>
          {accessToken && advanceAccount && advanceAccount.advanced && (
            <PointsCardContainer>
              <StyledPointsCard lite />
            </PointsCardContainer>
          )}
          <StyledRewardsList
            data={data}
            showRedeem={setShowRedeem}
            redeemRewardObject={setRedeemRewardObject}
          />
          <About>About {merchantName}</About>
          <Body dangerouslySetInnerHTML={{ __html: sanitizeHTML(body) }} />
          <About>Reminders</About>
          <RemindersList>
            {reminders &&
              reminders.map(reminder => (
                <Reminder key={reminder}>{reminder}</Reminder>
              ))}
          </RemindersList>
          <ResponsiveAdsContainer
            sideModal
            desktop={<DesktopLeaderboard id="div-ad-innity-91043/14" />}
            mobile={<MobileRectangle id="div-ad-innity-91046/14" />}
          />
          {/* {adType ? (
            <ResponsiveAdsContainer
              sideModal
              desktop={<DesktopLeaderboard id="div-ad-innity-91043/14" />}
              mobile={<MobileRectangle id="div-ad-innity-91046/14" />}
            />
          ) : (
            <ResponsiveAdsContainer
              sideModal
              desktop={<InnerPageLeaderboard id="div-totalmedia-14a" />}
              mobile={<InnerPageRectangle id="div-totalmedia-14b" />}
            />
          )} */}
        </Container>
      </SideModal>
      <RedeemSuccessModal
        show={!!showRedeemSuccess}
        onViewVoucher={() => displayProfileVoucher(showRedeemSuccess)}
        onViewWallet={() => displayProfileVoucher()}
      />
      {redeemRewardObject && (
        <>
          <DialogModal
            modalState={showRedeem}
            title={redeemRewardObject.title}
            description={
              <>
                <p>Are you sure you want to redeem?</p>
                <p>
                  Upon confirmation, we will deduct {redeemRewardObject.points}{' '}
                  points from your account.
                </p>
                <br />
                <p>
                  This voucher is valid for {redeemRewardObject.daysValid} days.
                </p>
              </>
            }
            align="center"
            okText="Proceed"
            onCancel={onDialogClose}
            cancelText="Not Now"
            onOk={() => redeemReward(redeemRewardObject.id)}
            wait
          />
          <DialogModal
            modalState={redeemError}
            title="Redemption Failed"
            description={redeemError}
            align="center"
            okText="OK"
            onOk={() => setRedeemError(null)}
            hasCancel={false}
          />
          <InsufficientPointsModal
            show={showInsufficientError}
            onConfirmClick={() => setShowInsufficientError(false)}
          />
        </>
      )}
    </>
  )
}

export default RewardsModal
